<template>
	<div>
		<table class="diff-table">
			<tr class="diff-row" v-for="(diff, index) in diffArray" :key="index">
				<!-- 難易度名 -->
				<td v-if="diff['key'] === '7key'" class="diff-name key-7">{{ diff['diff-name'] }}</td>
				<td v-else class="diff-name">{{ diff['diff-name'] }}</td>

				<!-- 難易度 -->
				<td class="diff-level-star">
					<div class="diff-level-star-labels">
						<label class="bigger-level-star level-star">{{ parseNumberToStar(digitDivision(getDiffLevel(diff), 2)) }}</label>
						<label class="normal-star level-star">{{ parseNumberToStar(digitDivision(getDiffLevel(diff), 1)) }}</label>
						<label class="level-num">{{ getDiffLevel(diff) }}</label>
					</div>
				</td>
			</tr>
		</table>
	</div>
</template>

<script>
export default {
	// diffArray[i]['key']: キー数
	// diffArray[i]['diff-name']: 難易度名
	// diffArray[i]['diff-level']: 難易度
	props: ['diffArray'],
	methods: {
		// 難易度のレベルを取得
		getDiffLevel: (diff) => diff['diff-level'],

		// 0~9を★の数に変換
		parseNumberToStar(number) {
			if(number >= 10) {
				return "";
			} else {
				let str = "";
				for(let i = 0; i < number; i++) {
					str += "★";
				}
				return str;
			}
		},

		// digit桁の値を取得
		digitDivision(number, digit) {
			if(digit < 1 || number.toString().length < digit) {
				return 0;
			}
			const levelStr = number.toString();
			return +levelStr.substring(levelStr.length - digit, levelStr.length - digit + 1);
				
		}

	}
}

</script>

<style scoped>
	.bigger-level-star {
		color: #F44336;
	}
	.key-7 {
		color: #3cb371;
	}
	.diff-name {
		padding: 0 8px;
		display: inline-block;
	}
	.level-num {
		margin-left: 8px;
	}

	.score-comment {
		text-align: left;
	}

</style>